import type { useContentContributorsDetailsPanelContentContributorsQuery as DetailsPanelContentContributorsQuery } from '../hooks/__types__/useContentContributorsDetailsPanelContentContributorsQuery';

export const normalizeContentContributorsData = (data?: DetailsPanelContentContributorsQuery) => ({
	nodes: data?.contentContributors?.nodes ?? [],
});
